export default __webpack_public_path__ + "static/media/ArjasariHoney.4b834fcc.png";